import { render, staticRenderFns } from "./NFreshDeliveryRowMobile.vue?vue&type=template&id=f3adf212&scoped=true&"
import script from "./NFreshDeliveryRowMobile.vue?vue&type=script&lang=ts&"
export * from "./NFreshDeliveryRowMobile.vue?vue&type=script&lang=ts&"
import style0 from "./NFreshDeliveryRowMobile.vue?vue&type=style&index=0&id=f3adf212&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3adf212",
  null
  
)

export default component.exports